import "./index.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _component = require("../_utils/component");

var _vueNormalizeComponent = _interopRequireDefault(require("../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: (0, _component.createComponentName)('video-dialog'),
  mixins: [_component.componentMixin],
  // 兼容元素标签引用的方式
  props: {
    videoShow: {
      type: Boolean,
      default: false
    },
    videoUrl: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      visible: false,
      url: '',
      autoplay: false,
      // 自动播放
      loop: false // 循环播放

    };
  },

  watch: {
    visible(value) {
      if (this.callback) {
        this.callback(value);
      }
    },

    videoShow(value) {
      this.visible = value;

      if (value) {
        this.url = this.videoUrl;
        document.documentElement.style.overflow = 'hidden';
      } else {
        this.url = '';
        document.documentElement.style.overflow = '';
      }
    }

  },

  beforeDestroy() {
    document.body.removeChild(this.$el);
  },

  methods: {
    close() {
      if (this.videoShow) {
        this.$emit('update:videoShow', false);
      } else {
        this.visible = false;
        this.url = '';
        document.documentElement.style.overflow = '';
      }
    }

  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("transition", {
    attrs: {
      name: "video-fade"
    }
  }, [_vm.visible ? _c("div", {
    class: _vm.bem()
  }, [_c("div", {
    class: _vm.bem("container")
  }, [_c("span", {
    class: _vm.bem("close"),
    on: {
      click: _vm.close
    }
  }, [_vm._v("+")]), _vm._v(" "), _c("video", {
    class: _vm.bem("player"),
    attrs: {
      src: _vm.url,
      autoplay: _vm.autoplay,
      loop: _vm.loop,
      controls: "",
      preload: "metadata",
      muted: "muted"
    },
    domProps: {
      muted: true
    }
  }, [_vm._v("\n                你的浏览器不支持 "), _c("code", [_vm._v("video")]), _vm._v(" 标签.\n            ")])])]) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default;